import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerSW } from "@/serviceWorkerRegistration";
import { installGlobalErrorHandlers } from "@/lib/clientErrors";

// 2026-02 Phase C4 — global client-error beacon.  Wired up BEFORE
// React mounts so a crash during initial render is still reported.
// Also stashes the SW version on window so the reporter can include
// it in every beacon (server side stores it as `sw_version`).
if (typeof window !== "undefined") {
  // Hardcoded to the current SW version so we don't have to import
  // the whole service-worker file (which isn't a JS module).  Bumped
  // alongside /app/frontend/public/service-worker.js.
  window.__GC_SW_VERSION = "v89";
  installGlobalErrorHandlers();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerSW();
